import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { StorageService } from 'src/app/services/auth/storage.service';
import { environment } from 'src/environments/environment';
import {
  MillenniumLookupResult,
  MillenniumReexportResult,
  isValidCompositionId
} from './composition-millennium';

interface ResponseB4A<T> {
  result: T;
}

@Injectable({ providedIn: 'root' })
export class CompositionMillenniumService {
  private http = inject(HttpClient);

  lookup(compositionId: number): Observable<MillenniumLookupResult> {
    this.assertCompositionId(compositionId);
    return this.http
      .get<ResponseB4A<MillenniumLookupResult>>(this.lookupUrl(compositionId), {
        headers: this.authHeaders()
      })
      .pipe(map((response) => response?.result));
  }

  reexport(compositionId: number): Observable<MillenniumReexportResult> {
    this.assertCompositionId(compositionId);
    return this.http
      .post<ResponseB4A<MillenniumReexportResult>>(
        `${this.lookupUrl(compositionId)}/reexport`,
        { confirm: true },
        { headers: this.authHeaders() }
      )
      .pipe(map((response) => response?.result));
  }

  private lookupUrl(compositionId: number): string {
    return `${environment.apiUrl}/composition/allocation/${encodeURIComponent(String(compositionId))}/millennium`;
  }

  private assertCompositionId(compositionId: number): void {
    if (!isValidCompositionId(compositionId)) {
      throw new Error('Composição inválida.');
    }
  }

  private authHeaders(): HttpHeaders {
    let headers = new HttpHeaders({ Accept: '*/*' });
    if (StorageService.token) {
      headers = headers.set('Authorization', `Bearer ${StorageService.token}`);
    }
    return headers;
  }
}
